import { render, staticRenderFns } from "./oddsTypeModal.vue?vue&type=template&id=9b32f8f8&lang=pug&"
import script from "./oddsTypeModal.vue?vue&type=script&lang=js&"
export * from "./oddsTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports